export default class HeaderController {
	constructor() {
		this.headerElement = null;
		this.menuButton = null;
		this.closeMenuButton = null;
		this.languageMarker = null;

		this.previousScroll = 0;
		this.scrollCounter = 0;
		this.threshold = 500;

		this.init();
		this.resize();
	}

	init() {
		this.headerElement = document.querySelector('header');
		this.overlayMenu = document.querySelector('section.overlayMenu');
		this.headerSearch = document.querySelector('section.headerSearch');
		this.searchButton = this.headerElement.querySelector('button.search');
		this.closeSearchButton = this.headerSearch.querySelector('button.closeSearch');
		this.menuButton = this.headerElement.querySelector('button.openMenu');
		this.closeMenuButton = document.querySelector('button.closeMenu');
		this.languageMarker = this.headerElement.querySelector('.activeLanguageMarker');
		this.previousScroll = window.pageYOffset;

		// Register events
		window.app.registerResizeEvent(this.resize.bind(this));
		window.app.registerScrollEvent(this.scroll.bind(this));

		// Click events
		this.menuButton.addEventListener('click', this.toggleMenu.bind(this));
		this.closeMenuButton.addEventListener('click', this.closeMenu.bind(this));

		this.searchButton.addEventListener('click', this.openSearch.bind(this));
		this.closeSearchButton.addEventListener('click', this.closeSearch.bind(this));

		this.headerSearch.querySelector('.background').addEventListener('click', this.closeSearch.bind(this));

		window.addEventListener('keydown', e => {
			if (e.key && e.key.substr(0, 3).toLowerCase() == 'esc') {
				this.closeMenu();
				this.closeSearch();
			}
		});

		if (document.body.classList.contains('homepage')) {
			this.initHomepageEffect();
		}

		this.initActiveLanguageMarker();
	}

	toggleMenu() {
		if (this.overlayMenu.classList.contains('active')) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	openMenu() {
		document.documentElement.classList.add('disableScroll');
		this.overlayMenu.classList.add('active');

		this.overlayMenu.setAttribute('aria-expanded', 'true');
		this.overlayMenu.setAttribute('aria-hidden', 'false');

		this.overlayMenu.querySelectorAll('input, a, button').forEach(interactive => interactive.setAttribute('tabindex', '0'));

		setTimeout(() => {
			this.overlayMenu.classList.remove('transitioning');
		}, 400);
	}

	closeMenu() {
		document.documentElement.classList.remove('disableScroll');
		this.overlayMenu.classList.remove('active');

		this.overlayMenu.setAttribute('aria-expanded', 'false');
		this.overlayMenu.setAttribute('aria-hidden', 'true');

		this.overlayMenu.querySelectorAll('input, a, button').forEach(interactive => interactive.setAttribute('tabindex', '-1'));
	}

	toggleSearch() {
		if (this.overlayMenu.classList.contains('active')) {
			this.closeSearch();
		} else {
			this.openSearch();
		}
	}

	openSearch() {
		if (this.headerSearch.classList.remove('transitioning')) {
			return;
		}

		document.documentElement.classList.add('disableScroll');
		this.headerSearch.classList.add('active');
		this.headerSearch.classList.add('transitioning');

		this.headerSearch.setAttribute('aria-expanded', 'true');
		this.headerSearch.setAttribute('aria-hidden', 'false');

		this.headerSearch.querySelectorAll('input, a, button').forEach(interactive => interactive.setAttribute('tabindex', '0'));
		
		setTimeout(() => {
			if (this.headerSearch.classList.contains('active')) {
				this.headerSearch.querySelector('input[type="text"]').focus();
			}
		}, 500);

		setTimeout(() => {
			this.headerSearch.classList.remove('transitioning');
		}, 400);
	}

	closeSearch() {
		if (this.headerSearch.classList.remove('transitioning')) {
			return;
		}

		document.documentElement.classList.remove('disableScroll');
		this.headerSearch.classList.remove('active');
		this.headerSearch.classList.add('transitioning');

		this.headerSearch.setAttribute('aria-expanded', 'false');
		this.headerSearch.setAttribute('aria-hidden', 'true');

		this.headerSearch.querySelectorAll('input, a, button').forEach(interactive => interactive.setAttribute('tabindex', '-1'));
		this.headerSearch.querySelector('input[type="text"]').blur();

		setTimeout(() => {
			this.headerSearch.classList.remove('transitioning');
		}, 400);
	}

	resize() {
		this.previousScroll = window.pageYOffset;
		this.threshold = this.headerElement.clientHeight;

		this.scroll();
	}

	scroll() {
		if (window.pageYOffset > 160) {
			this.hide();
		} else {
			this.show();
		}
	}

	hide() {
		this.headerElement.classList.add('small');
	}

	show() {
		this.headerElement.classList.remove('small');
	}

	initHomepageEffect() {
		let windowHeight = window.innerHeight;

		app.registerResizeEvent(() => {
			windowHeight = window.innerHeight;
		});

		app.registerScrollEvent(() => {
			if ((document.documentElement.scrollTop || document.body.scrollTop) > windowHeight - this.headerElement.clientHeight) {
				this.headerElement.classList.add('notOverlappingHero');
			} else {
				this.headerElement.classList.remove('notOverlappingHero');
			}
		});
	}

	initActiveLanguageMarker() {
		// Find available options
		let options = Array.from(this.headerElement.querySelectorAll('.languageSelection li'));
		let currentOption = options.filter(li => li.querySelector('a').classList.contains('active'))[0];

		const focus = option => {
			const navPosition = this.headerElement.querySelector('nav.options').getBoundingClientRect();
			const optionPosition = option.getBoundingClientRect();

			// Calculate marker's width and position
			this.languageMarker.style.width = optionPosition.width + 'px';
			this.languageMarker.style.left = (optionPosition.left - navPosition.left) + 'px';
		};

		

		options.forEach(option => {
			['mouseenter', 'focus'].forEach(event => {
				option.addEventListener(event, e => {
					e.preventDefault();
					focus(option);
				});
			});

			['mouseleave', 'blur'].forEach(event => {
				option.addEventListener(event, e => {
					e.preventDefault();
					focus(currentOption);
				});
			});
		});

		setTimeout(() => {
			focus(currentOption);
			this.languageMarker.classList.add('active');
		}, 200);

		window.app.registerResizeEvent(focus.bind(this, currentOption));
	}
}